import style from "./ChatManagementLayout.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { useEffect, useRef, useState } from "react";
import { adminFileRequester, adminRequester, socketRequester } from "App";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";
import { style as buttonStyle } from "components/buttons/AdminCustomButton";
import ToolTip from "components/tooltip/tooltip";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import InputText from "components/inputs/InputText";
import { useSearchParams } from "react-router-dom";
import { t } from "i18next";
import { toast } from "react-toastify";
import AdminImage from "components/Image/AdminImage";
import FlexGrid from "layouts/flex/FlexGrid";
import NiceModal from "@ebay/nice-modal-react";
export const limit = 60;
function ChatManagementLayout(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [mounted, setMounted] = useState(false);
  const [user, setUser] = useState();
  const [chatroom, setChatroom] = useState();
  const [chatrooms, setChatrooms] = useState([]);
  const [chats, setChats] = useState([]);
  const [height, setHeight] = useState();
  const [searchInterval, setSearchInterval] = useState();
  const [scrollHeight, setScrollHeight] = useState(0);
  const [loadable, setLoadable] = useState(false);
  const [offset, setOffset] = useState(0);
  const [max, setMax] = useState(limit);
  const [open, setOpen] = useState(false);
  const chatsRef = useRef();
  const roomsRef = useRef();
  const searchRef = useRef();
  const inputRef = useRef();
  const buttonRef = useRef();
  const scrollDivRef = useRef();

  const handleWindowSizeChange = () => {
    setHeight(window.innerHeight - 128 - 20);
  };
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    handleWindowSizeChange();
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (mounted) {
      adminRequester.getCurrentUser((result) => {
        const user = result.user;
        setUser(user);
        adminRequester.getChatrooms(
          { user: user.id, expand: "users,customers" },
          (result) => {
            const chatrooms = result.chatrooms;
            roomsRef.current = chatrooms;
            setChatrooms(chatrooms);
            if (chatrooms?.length > 0) setChatroom(chatrooms[0]);
          }
        );
      });
    }
  }, [mounted]);
  useEffect(() => {
    if (chatroom) {
      const pre = searchParams.get("room_id");
      if (pre) {
        socketRequester.unSubscribe(`chatroom/${pre}`);
      }
      searchParams.set("room_id", chatroom?.id);
      socketRequester.subscribe(`chatroom/${chatroom?.id}`, (res) => {
        if (res.status === 200) {
          chatsRef.current = [...chatsRef.current, res.data.chat];
          if (res.data?.room) {
            roomsRef.current = roomsRef.current.map((room) => {
              if (room.id === res.data.room?.id) return res.data.room;
              return room;
            });
            setChatrooms(roomsRef.current);
          }
          setChats(chatsRef.current);
          setScrollHeight(null);
          setScrollHeight(0);
        } else if (res.status === 404) {
          
        }
      });
      setSearchParams(searchParams);
      adminRequester.getChat(
        chatroom.id,
        { expand: "user,customer", limit: limit },
        (result) => {
          chatsRef.current = result.chats.reverse();
          setOffset(chatsRef.current.length);
          setMax(result.count);
          setChats([...chatsRef.current]);
          setScrollHeight(null);
          setScrollHeight(0);
        }
      );
    }
  }, [chatroom]);
  useEffect(() => {
    if (scrollDivRef.current && scrollHeight !== null) {
      const maxHeight =
        scrollDivRef.current.scrollHeight - scrollDivRef.current.clientHeight;
      scrollDivRef.current.scrollTop = maxHeight - scrollHeight;
      setLoadable(true);
    }
  }, [scrollDivRef, scrollHeight]);

  const RoomAvatar = ({ room, onClick, selected = false }) => {
    let target;
    if (room?.customers?.length > 0) {
      target = room.customers
        .sort(customerCompare)[0]
        ?.first_name[0].toUpperCase();
    } else if (room?.users?.length > 0) {
      const users = room.users.sort(userCompare);
      target = users[users?.length - 1]?.first_name[0].toUpperCase();
    }
    return (
      <div
        className={clsx(style.avatar, { [style.selected]: selected })}
        onClick={onClick}
      >
        <P size="2.5rem">{target}</P>
      </div>
    );
  };
  const Avatar = ({ name, small = true }) => {
    return (
      <div className={clsx(style.avatar, { [style.small]: small })}>
        <P size={small ? "1rem" : "2rem"}>{name[0].toUpperCase()}</P>
      </div>
    );
  };
  const customerCompare = (a, b) => {
    return `${a.first_name} ${a.last_name}`.localeCompare(
      `${b.first_name} ${b.last_name}`
    );
  };
  const userCompare = (a, b) => {
    if (a.role === b.role)
      return `${a.first_name} ${a.last_name}`.localeCompare(
        `${b.first_name} ${b.last_name}`
      );
    else if (a?.role === "admin") {
      return -1;
    } else {
      return 1;
    }
  };

  const onSearch = () => {
    const value = searchRef.current.getValue();
    const data = {
      user: user?.id,
      expand: "users,customers",
    };
    if (value) data.t = value;
    adminRequester.getChatrooms(data, (result) => {
      const chatrooms = result.chatrooms;
      roomsRef.current = chatrooms;
      setChatrooms(chatrooms);
    });
  };
  const dateToString = (date) => {
    date = new Date(date);
    const now = new Date();

    if (date.toISOString().split("T")[0] === now.toISOString().split("T")[0]) {
      return `${t("date_today")} ${t(
        date.getHours() < 12 ? "A.M." : "P.M."
      )} ${String(date.getHours() % 12).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}`;
    } else
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")} ${t(
        date.getHours() < 12 ? "A.M." : "P.M."
      )} ${String(date.getHours() % 12).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")}`;
  };
  const isSimilar = (chat1, chat2) => {
    if (!chat1 || !chat2 || chat1.user?.id !== chat2.user?.id) return false;

    const date1 = new Date(chat1.updated_at);
    const date2 = new Date(chat2.updated_at);

    return date2.getTime() - date1.getTime() < 1000 * 60 * 2;
  };

  const Chat = ({ chat, other, index, list }) => {
    const pre = isSimilar(list?.[index - 1], chat);
    const next = isSimilar(chat, list?.[index + 1]);
    return (
      <FlexChild
        width="max-content"
        alignSelf={other ? "flex-start" : "flex-end"}
        height="max-content"
        maxHeight="max-content"
      >
        <HorizontalFlex gap={10}>
          {other &&
            (pre ? (
              <FlexChild width="56px"></FlexChild>
            ) : (
              <FlexChild>
                <Avatar name={chat?.user?.first_name || " "} small={false} />
              </FlexChild>
            ))}
          <VerticalFlex alignItems="flex-start">
            {other && !pre && (
              <FlexChild width="max-content">
                <P padding={2}>{`${chat.user.first_name}${
                  chat.user.last_name ? ` ${chat.user.last_name}` : ""
                }`}</P>
              </FlexChild>
            )}

            {other ? (
              <HorizontalFlex
                gap={10}
                justifyContent={"flex-start"}
                alignItems="flex-end"
              >
                <FlexChild>
                  <Message chat={chat} />
                </FlexChild>
                {!next && (
                  <FlexChild width="max-content">
                    <P padding={2} size={12}>
                      {dateToString(chat?.updated_at)}
                    </P>
                  </FlexChild>
                )}
              </HorizontalFlex>
            ) : (
              <HorizontalFlex
                gap={10}
                justifyContent={"flex-end"}
                alignItems="flex-end"
              >
                {!next && (
                  <FlexChild width="max-content">
                    <P padding={2} size={12}>
                      {dateToString(chat?.updated_at)}
                    </P>
                  </FlexChild>
                )}
                <FlexChild>
                  <Message chat={chat} />
                </FlexChild>
              </HorizontalFlex>
            )}
          </VerticalFlex>
        </HorizontalFlex>
      </FlexChild>
    );
  };
  const Message = ({ chat }) => {
    switch (chat?.metadata?.type) {
      case "image": {
        const images = chat?.metadata?.images;
        return (
          <FlexGrid
            gap={10}
            columns={Math.min(3, images?.length)}
            rows={Math.min(1, Math.ceil(images?.length / 3))}
            className={style.chat}
          >
            {images.map((image) => (
              <AdminImage
                key={image.key}
                width={200}
                src={image.url}
                success={{
                  onClick: () =>
                    NiceModal.show("openImage", { src: image.url }),
                }}
              />
            ))}
          </FlexGrid>
        );
      }
      default:
        return (
          <P id={chat.id} className={style.chat}>
            {chat.message}
          </P>
        );
    }
  };

  return (
    <div className={style.container}>
      <HorizontalFlex alignItems="flex-start" padding={10} gap={20}>
        <FlexChild width="15%" padding={5} maxHeight={height}>
          <VerticalFlex gap={10}>
            <FlexChild>
              <InputText
                placeHolder="Search..."
                validable={false}
                ref={searchRef}
                onChange={() => {
                  if (mounted) {
                    if (searchInterval) clearInterval(searchInterval);
                    const interval = setInterval(() => {
                      onSearch();
                      clearInterval(interval);
                    }, 1000);
                    setSearchInterval(interval);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") onSearch();
                }}
              />
            </FlexChild>
            <VerticalFlex
              gap={10}
              maxHeight={height - 38 - 10}
              height={height - 38 - 10}
              overflowY="auto"
              hideScrollbar
              alignItems="flex-start"
            >
              {chatrooms?.map((room) => (
                <FlexChild key={room.id}>
                  <div
                    className={clsx(style.rooms, {
                      [style.selected]: chatroom?.id === room?.id,
                    })}
                    onClick={() => {
                      setChats([]);
                      setChatroom(room);
                    }}
                  >
                    <HorizontalFlex gap={20}>
                      <FlexChild width="max-content">
                        <RoomAvatar
                          room={room}
                          selected={chatroom?.id === room?.id}
                        />
                      </FlexChild>
                      <FlexChild height="100%" width="75%">
                        <VerticalFlex
                          justifyContent="space-between"
                          alignItems="flex-start"
                          height="100%"
                          padding={10}
                        >
                          <HorizontalFlex>
                            <FlexChild width="max-content">
                              <P>{room.title}</P>
                            </FlexChild>
                            <FlexChild width="max-content">
                              <P>
                                {room.updated_at
                                  ?.replace("T", " ")
                                  .slice(0, 16)}
                              </P>
                            </FlexChild>
                          </HorizontalFlex>
                          <FlexChild width="inherit">
                            <P
                              width="inherit"
                              wordBreak="keep-all"
                              whiteSpace="no-wrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                            >
                              {room.metadata?.last_message
                                ? room.metadata.last_message
                                : " "}
                            </P>
                          </FlexChild>
                        </VerticalFlex>
                      </FlexChild>
                    </HorizontalFlex>
                  </div>
                </FlexChild>
              ))}
            </VerticalFlex>
          </VerticalFlex>
        </FlexChild>
        <FlexChild height={height}>
          <div
            style={{
              padding: 10,
              width: "80%",
              height: "100%",
              border: "1px solid gray",
              borderRadius: 10,
            }}
          >
            <VerticalFlex gap={10} height="100%">
              <FlexChild height="min-content">
                <div
                  style={{
                    borderBottom: "1px solid #a0a0a0",
                    padding: 10,
                  }}
                >
                  <HorizontalFlex padding={10}>
                    <FlexChild width="max-content">
                      <P size={24}>{chatroom?.title}</P>
                    </FlexChild>
                    <FlexChild width="max-content">
                      <ToolTip
                        style={{
                          backgroundColor: "white",
                          border: "1px solid black",
                          borderRadius: "15px",
                          width: "max-content",
                          padding: 15,
                        }}
                        title={
                          <VerticalFlex alignItems="flex-start" gap={10}>
                            {chatroom?.users?.sort(userCompare)?.map((user) => {
                              const name = `${user?.first_name}${
                                user?.last_name ? ` ${user?.last_name}` : ""
                              }`;
                              return (
                                <HorizontalFlex
                                  key={user.id}
                                  gap={10}
                                  justifyContent="flex-start"
                                >
                                  <FlexChild width="max-content">
                                    <Avatar name={name} />
                                  </FlexChild>
                                  <FlexChild width="max-content">
                                    <P>{name}</P>
                                  </FlexChild>
                                </HorizontalFlex>
                              );
                            })}
                            {chatroom?.customers
                              ?.sort(customerCompare)
                              ?.map((customer) => {
                                const name = `${customer?.first_name}${
                                  customer?.last_name
                                    ? ` ${customer?.last_name}`
                                    : ""
                                }`;
                                return (
                                  <HorizontalFlex
                                    key={customer.id}
                                    gap={10}
                                    justifyContent="flex-start"
                                  >
                                    <FlexChild width="max-content">
                                      <Avatar name={name} />
                                    </FlexChild>
                                    <FlexChild width="max-content">
                                      <P>{name}</P>
                                    </FlexChild>
                                  </HorizontalFlex>
                                );
                              })}
                          </VerticalFlex>
                        }
                        top={"100%"}
                      >
                        <P cursor size={24}>
                          참가자
                        </P>
                      </ToolTip>
                    </FlexChild>
                  </HorizontalFlex>
                </div>
              </FlexChild>
              <FlexChild backgroundColor="#c0c0c0" padding={10} height="95%">
                <div
                  ref={scrollDivRef}
                  style={{
                    width: "100%",
                    height: "91.5%",
                    marginBottom: "1%",
                    paddingLeft: "5%",
                    paddingRight: "5%",
                    overflowY: "scroll",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                  }}
                  onWheel={(e) => {
                    const maxHeight =
                      scrollDivRef.current.scrollHeight -
                      scrollDivRef.current.clientHeight;
                    const now = Math.max(
                      -30,
                      scrollDivRef.current.scrollTop + e.deltaY
                    );
                    if (
                      loadable &&
                      (now / maxHeight) * 100 < 30 &&
                      offset < max
                    ) {
                      setLoadable(false);
                      adminRequester.getChat(
                        chatroom.id,
                        {
                          expand: "user,customer",
                          limit: limit,
                          offset: offset,
                        },
                        (result) => {
                          chatsRef.current = [
                            ...result.chats.reverse(),
                            ...chatsRef.current,
                          ];
                          setOffset(chatsRef.current.length);
                          setMax(result.count);
                          setChats(chatsRef.current);
                          setLoadable(true);
                          setScrollHeight(maxHeight - now);
                        }
                      );
                    }
                  }}
                >
                  <VerticalFlex gap={10} justifyContent="flex-end">
                    {chats &&
                      chats?.map((chat, index, list) => (
                        <Chat
                          key={chat?.id}
                          chat={chat}
                          index={index}
                          list={list}
                          other={chat?.user?.id !== user?.id}
                        />
                      ))}
                  </VerticalFlex>
                </div>
                <div
                  style={{
                    height: "5%",
                    paddingLeft: "5%",
                    paddingRight: "5%",
                  }}
                >
                  <HorizontalFlex borderRadius="28px" backgroundColor="white">
                    <FlexChild width={10} />
                    <FlexChild>
                      <InputText
                        ref={inputRef}
                        placeHolder="message..."
                        validable={false}
                        style={{ borderWidth: "0" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") buttonRef.current.click();
                        }}
                      />
                    </FlexChild>
                    <FlexChild width="max-content">
                      <AdminCustomButton
                        text="Send"
                        style={buttonStyle.white_border}
                        Ref={buttonRef}
                        onClick={() => {
                          const message = inputRef.current.getValue();
                          if (message && chatroom && chatroom?.id)
                            socketRequester.publish(`chatroom`, {
                              room: chatroom?.id,
                              message: message,
                              user: user?.id,
                            });
                          inputRef.current.empty();
                        }}
                      />
                    </FlexChild>
                    <FlexChild width="max-content">
                      <div
                        style={{ width: "max-content", position: "relative" }}
                      >
                        {open && (
                          <div
                            style={{
                              width: "100vw",
                              height: "100vh",
                              position: "fixed",
                              left: 0,
                              top: 0,
                              backgroundColor: "rgba(176,176,176,0.4)",
                              zIndex: 9999,
                            }}
                            onClick={() => setOpen(false)}
                          />
                        )}
                        {open && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: "120%",
                              left: "50%",
                              width: "max-content",
                              padding: 10,
                              backgroundColor: "white",
                              borderRadius: 15,
                              transform: "translate(-50%, 0%)",
                              zIndex: 10000,
                            }}
                          >
                            <HorizontalFlex>
                              <FlexChild width="max-content">
                                <AdminCustomButton
                                  text="이미지"
                                  style={{
                                    ...buttonStyle.white,
                                  }}
                                  type="file"
                                  accept="image/*"
                                  multiple={true}
                                  onChange={async (e) => {
                                    const { allow, files } = Object.keys(
                                      e.files
                                    )
                                      .filter((f) => f !== "length")
                                      .reduce(
                                        (acc, key) => {
                                          if (
                                            !acc.allow ||
                                            !e.files[key]?.type?.includes(
                                              "image"
                                            )
                                          )
                                            return { allow: false, files: [] };
                                          acc.files.push(e.files[key]);
                                          return acc;
                                        },
                                        { allow: true, files: [] }
                                      );

                                    if (allow) {
                                      const formData = new FormData();
                                      files.map((file) =>
                                        formData.append("files", file)
                                      );
                                      formData.append("destination", "images");

                                      let uploadResult = await adminFileRequester.upload(
                                        formData,
                                        "/images"
                                      );
                                      if (uploadResult?.uploads?.length > 0) {
                                        socketRequester.publish(`chatroom`, {
                                          room: chatroom?.id,
                                          user: user?.id,
                                          metadata: {
                                            type: "image",
                                            images: uploadResult?.uploads,
                                          },
                                        });
                                      }
                                    } else {
                                      toast.error(
                                        "이미지 이외의 목록은 담을 수 없습니다.",
                                        {
                                          autoClose: 1000,
                                          position: "bottom-center",
                                        }
                                      );
                                    }
                                    setOpen(false);

                                    e.value = null;
                                  }}
                                />
                              </FlexChild>
                              <FlexChild width="max-content">
                                <AdminCustomButton
                                  text="파일"
                                  style={{
                                    ...buttonStyle.white,
                                  }}
                                  type="file"
                                  multiple={true}
                                  onChange={async (e) => {
                                    const { allow, files } = Object.keys(
                                      e.files
                                    )
                                      .filter((f) => f !== "length")
                                      .reduce(
                                        (acc, key) => {
                                          if (
                                            !acc.allow ||
                                            !e.files[key]?.type?.includes(
                                              "image"
                                            )
                                          )
                                            return { allow: false, files: [] };
                                          
                                          acc.files.push(e.files[key]);
                                          return acc;
                                        },
                                        { allow: true, files: [] }
                                      );

                                    // if (allow) {
                                    if (false) {
                                      const formData = new FormData();
                                      files.map((file) =>
                                        formData.append("files", file)
                                      );

                                      let uploadResult = await adminFileRequester.upload(
                                        formData
                                      );
                                      if (uploadResult?.uploads?.length > 0) {
                                        socketRequester.publish(`chatroom`, {
                                          room: chatroom?.id,
                                          user: user?.id,
                                          metadata: {
                                            type: "image",
                                            images: uploadResult?.uploads,
                                          },
                                        });
                                      }
                                    } else {
                                      toast.error(
                                        "이미지 이외의 목록은 담을 수 없습니다.",
                                        {
                                          autoClose: 1000,
                                          position: "bottom-center",
                                        }
                                      );
                                    }
                                    setOpen(false);

                                    e.value = null;
                                  }}
                                />
                              </FlexChild>
                            </HorizontalFlex>
                          </div>
                        )}
                        <FlexChild width="max-content">
                          <AdminCustomButton
                            text="+"
                            style={{
                              ...buttonStyle.white_border,
                              width: "35px",
                              borderRadius: "100%",
                            }}
                            // onClick={() => setOpen(!open)}
                            type="file"
                            accept="image/*"
                            multiple={true}
                            onChange={async (e) => {
                              const { allow, files } = Object.keys(e.files)
                                .filter((f) => f !== "length")
                                .reduce(
                                  (acc, key) => {
                                    if (
                                      !acc.allow ||
                                      !e.files[key]?.type?.includes("image")
                                    )
                                      return { allow: false, files: [] };
                                    acc.files.push(e.files[key]);
                                    return acc;
                                  },
                                  { allow: true, files: [] }
                                );

                              if (allow) {
                                const formData = new FormData();
                                files.map((file) =>
                                  formData.append("files", file)
                                );

                                formData.append("destination", "images");

                                let uploadResult = await adminFileRequester.upload(
                                  formData,
                                  "/images"
                                );
                                if (uploadResult?.uploads?.length > 0) {
                                  socketRequester.publish(`chatroom`, {
                                    room: chatroom?.id,
                                    user: user?.id,
                                    metadata: {
                                      type: "image",
                                      images: uploadResult?.uploads,
                                    },
                                  });
                                }
                              } else {
                                toast.error(
                                  "이미지 이외의 목록은 담을 수 없습니다.",
                                  {
                                    autoClose: 1000,
                                    position: "bottom-center",
                                  }
                                );
                              }
                              setOpen(false);

                              e.value = null;
                            }}
                          />
                        </FlexChild>
                      </div>
                    </FlexChild>
                    <FlexChild width={10} />
                  </HorizontalFlex>
                </div>
              </FlexChild>
            </VerticalFlex>
          </div>
        </FlexChild>
      </HorizontalFlex>
    </div>
  );
}

export default ChatManagementLayout;
